if (typeof Connect == 'undefined') Connect = { contextRoot: '/connect' };

Connect.ApplicationCapabilities = {
    'DUMMY': [ 'CREATE_INVOICE', 'IMPORT_CUSTOMER', 'EXPORT_CUSTOMER', 'IMPORT_ARTICLE', 'EXPORT_ARTICLE' ],
    'BILLOGRAM': [ 'CREATE_INVOICE', 'IMPORT_CUSTOMER', 'EXPORT_CUSTOMER', 'IMPORT_ARTICLE', 'EXPORT_ARTICLE' ],
    'PEACCOUNTING': [ 'CREATE_INVOICE' ],
    'FORTNOX': [ 'CREATE_INVOICE', 'IMPORT_CUSTOMER', 'EXPORT_CUSTOMER', 'IMPORT_ARTICLE', 'EXPORT_ARTICLE', 'READ_ORDER' ],
    'BILLECTA': [ 'CREATE_INVOICE' ],
    'VISMAEEKONOMI': [ 'CREATE_INVOICE' ],
    'SCANIAFMP': [ 'AUTHENTICATE', 'READ_USER', 'READ_ASSET', 'IMPORT_USER', 'IMPORT_ASSET', 'IMPORT_ASSET_LOCATION' ],
    'SCANIASEIP': [ 'CREATE_INVOICE '],
    'INFOTRADER': [ 'UPDATE_REPORT','LOG_TRANSACTIONS' ],
    'UNGAPPED': ['CSAT', 'LOG_TRANSACTIONS'],
    'TRACKUNIT': ['READ_ASSET', 'IMPORT_ASSET'],
    'BJORNLUNDEN': ['CREATE_INVOICE'],
    'VISMANET': ['CREATE_INVOICE'],
    'VISMAPUBLICROR': ['CREATE_INVOICE'],
    'RAINDANCE': ['CREATE_INVOICE'],
    'TELLUS': ['READ_VEHICLE_ENV_DATA'],
    'PEPPOL': ['LOG_TRANSACTIONS'],
    'NVV': ['REPORT_TRANSPORT_DOCUMENT', 'LOG_TRANSACTIONS'],
};

Connect.ApplicationDefaults = {
    'DUMMY': {
        actions: [ 'CREATE_INVOICE' ]
    },
    'BILLOGRAM': {
        actions: [ 'CREATE_INVOICE' ]
    },
    'PEACCOUNTING': {
        actions: [ 'CREATE_INVOICE' ]
    },
    'FORTNOX': {
        actions: [ 'CREATE_INVOICE' ]
    },
    'BILLECTA': {
        actions: [ 'CREATE_INVOICE' ]
    },
    'INFOTRADER': {
        actions: [ 'UPDATE_REPORT']
    },
    'VISMAEEKONOMI': {
        actions: [ 'CREATE_INVOICE' ]
    },
    'UNGAPPED': {
        actions: ['CSAT']
    },
    'SCANIAFMP': {
        actions: [ 'AUTHENTICATE', 'READ_USER', 'READ_ASSET' ]
    },
    'SCANIASEIP': {
        actions: [ 'CREATE_INVOICE' ],
        configuration: {
            source: 'COREDINAT',
            unit: '0038',
            country: 'SE',
            defaultOurReference: 'EB, transportlaboratorium@scania.com',
            defaultAccount: '3031',
            project: '000000',
            activity: '0117',
            subAccount: '0000',
            customerNoField: 'finesskundnr',
        }
    },
    'TRACKUNIT': {
        actions: ['READ_ASSET']
    },
    'BJORNLUNDEN': {
        actions: ['CREATE_INVOICE']
    },
    'VISMANET': {
        actions: ['CREATE_INVOICE']
    },
    'VISMAPUBLICROR': {
        actions: ['CREATE_INVOICE']
    },
    'RAINDANCE': {
        actions: ['CREATE_INVOICE']
    },
    'TELLUS': {
        actions: ['READ_VEHICLE_ENV_DATA']
    },
    'NVV': {
        actions: ['REPORT_TRANSPORT_DOCUMENT']
    }
};

Connect.Integration = Backbone.Model.extend({
    urlRoot: Connect.contextRoot + '/integration',

    verifyConnection: function() {
        var self = this;
        return $.ajax({
            url: this.urlRoot + '/verify',
            type: 'POST',
            data: JSON.stringify(this.toJSON()),
            dataType: 'json',
            contentType: 'application/json',
            success: function(data) {
                if (self.id) delete data.id;
                if (data) self.set(data);
            }
        });
    }
});

Connect.Integrations = Backbone.Collection.extend({
    model: Connect.Integration,
    url: function() {
        if (!this.groupUuid) throw 'Missing groupUuid';
        return Connect.contextRoot + '/integration/group/' + this.groupUuid;
    },
    initialize: function(models, options) {
        this.groupUuid = options.groupUuid;
    },
    getApplication: function(application) {
        return this.where({application: application});
    },
    addApplication: function(application) {
        var model = new Connect.Integration({ application: application, groupUuid: this.groupUuid });
        model.set(Connect.ApplicationDefaults[application]);
        model.set({enabled: true});
        this.add(model);
        return model;
    }
});

Connect.CustomerCount = Backbone.Model.extend({
    url: Connect.contextRoot + '/customer/count'
});

Connect.ArticleCount = Backbone.Model.extend({
    url: Connect.contextRoot + '/article/count'
});
